import type { ReactNode } from "react";

/** Ред в легендата: мостра + надпис (общ за схемата и таблицата). */
const LegendItem = ({ swatch, children }: { swatch: ReactNode; children: ReactNode }) => (
  <span className="flex items-center gap-2 whitespace-nowrap text-[12.5px] font-medium text-ink-2">
    {swatch}
    {children}
  </span>
);

export default LegendItem;
